import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowUpRight} from 'lucide-react';
import WorkflowIcon from './WorkflowIcon';

/** Shared Lexa-inspired composition. Values, permissions and actions belong to the caller. */
export default function WorkspaceHeader({eyebrow,title,description,actions,children}) {
  return <header className="workspace-heading">
    <div className="workspace-heading-copy">{eyebrow&&<p className="workspace-eyebrow">{eyebrow}</p>}<h1>{title}</h1>{description&&<p className="workspace-description">{description}</p>}{children}</div>
    {actions&&<div className="workspace-heading-actions">{actions}</div>}
  </header>;
}

export function WorkspaceTasks({title,description,items}) {
  return <section className="workspace-tasks" aria-label={title}>
    <div className="workspace-section-heading"><h2>{title}</h2>{description&&<p>{description}</p>}</div>
    <div className="workspace-task-grid">{items.map(item=><Link key={item.to} to={item.to} className="workspace-task">
      <span className="workspace-task-number" aria-hidden="true"><WorkflowIcon label={item.title}/></span><span><strong>{item.title}</strong><small>{item.description}</small></span><ArrowUpRight size={17} aria-hidden="true"/>
    </Link>)}</div>
  </section>;
}

export function PreparationAction({summary,dirty,onComplete,onReview}) {
  const ready=summary.ready_for_validation===true;
  return <section className="workspace-next-action" aria-label="Next preparation action">
    <div><p className="workspace-eyebrow">Next action</p><h2>{ready?'Send the prepared copy for validation':'Complete the product information'}</h2>
      <p>{ready?'The required details are present. The regulatory team must still review them.':'Reuse saved records and documents. Check missing answers and changed sources before sending for review.'}</p></div>
    <button type="button" className="vl-primary" disabled={dirty} onClick={ready?onReview:onComplete}>{ready?'Go to handoff':'Open answers & evidence'}</button>
  </section>;
}
